import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import { ThemeProvider } from './contexts/ThemeContext'
import { registerServiceWorker } from './pwaSetup'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import amplifyConfig from './amplifyconfiguration'
import './styles/index.css'
import './styles/theme.css'

// Configure Amplify if Cognito is set up
if (import.meta.env.VITE_COGNITO_USER_POOL_ID && import.meta.env.VITE_COGNITO_CLIENT_ID) {
  Amplify.configure(amplifyConfig)
  console.log('Amplify configured with Cognito authentication')
} else {
  console.log('Using legacy JWT authentication')
}

// Register service worker for PWA support
registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
